import { RawTimeseriesResponsePayload } from '@va/types/time-series';
import { LineChart } from '@va/ui/design-system';
import { hex2rgbString } from '@va/util/helpers';
import { ChartDataset } from 'chart.js';
import { useMemo } from 'react';

export const Trendline = ({
  id,
  data,
  color: colorProp,
}: {
  id: string;
  data: RawTimeseriesResponsePayload;
  color?: string;
}) => {
  const datasets: ChartDataset<'line', number[]>[] = useMemo(() => {
    const total = data?.datasets?.[0]?.total ?? 0;

    let color = colorProp ?? window.PRIMARY_COLOR;
    if (!colorProp && total === 0) {
      color = '#B8B8B8';
    }

    return [
      {
        label: 'trendline-dataset',
        data: data.datasets?.[0]?.data ?? [],
        borderWidth: 2,
        borderColor: color,
        fill: true,
        // @ts-ignore
        backgroundColor: (context) => {
          const ctx = context.chart.ctx;
          const gradient = ctx.createLinearGradient(0, 0, 0, 16);
          const rgbString = hex2rgbString(color);
          gradient.addColorStop(0, `rgba(${rgbString}, 1)`);
          gradient.addColorStop(1, `rgba(${rgbString}, 0.1)`);

          return gradient;
        },
      },
    ];
  }, [data.datasets, colorProp]);

  if (data.datasets.length === 0) {
    return null;
  }

  return (
    <div className={'w-9 max-w-9 max-h-full'}>
      <LineChart
        id={`${id}-trend-line`}
        tooltipFn={() => null}
        chartData={{
          labels: data.labels,
          datasets: datasets,
        }}
        configOptions={{
          hideAllScales: true,
        }}
        wrapperStyle={{
          height: '100%',
          maxHeight: '16px',
        }}
      />
    </div>
  );
};
